"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetMailSuffix = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var certification_1 = require("../../model/certification");
var service_1 = require("../../../library/base/service");
var GetMailSuffix = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(GetMailSuffix, _super);
    function GetMailSuffix() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '获取邮箱后缀';
        _this.code = '101167';
        _this.desc = '获取邮箱后缀';
        _this.requestParams = new certification_1.GetMailSuffixRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return GetMailSuffix;
}(service_1.BaseService));
exports.GetMailSuffix = GetMailSuffix;
//# sourceMappingURL=getMailSuffix.js.map